import { GuestBrandedDefaultColors, GuestBrandedDefaultFonts } from 'common/compounds/GuestBrandedTheme/constants';
import 'common/compounds/GuestBrandedTheme/guestBranded.css';

export const CookieBannerContainerStyles = {
    container: {
        display: 'flex',
        maxWidth: '976px',
        padding: '24px',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        borderRadius: '0.625rem',
        background: `var(--guest-branded-background, ${GuestBrandedDefaultColors.background})`,
        color: `var(--guest-branded-text, ${GuestBrandedDefaultColors.text})`,
        boxShadow: '0 4px 20px -2px rgba(0, 0, 0, 0.25)',
        textAlign: 'left',
        fontFamily: `var(--guest-branded-font-body, ${GuestBrandedDefaultFonts.body})`,
    },
    modal: {
        display: 'flex',
        padding: '24px',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        borderRadius: '0.625rem',
        background: `var(--guest-branded-background, ${GuestBrandedDefaultColors.background})`,
        color: `var(--guest-branded-text, ${GuestBrandedDefaultColors.text})`,
        boxShadow: '0 4px 20px -2px rgba(0, 0, 0, 0.25)',
        fontFamily: `var(--guest-branded-font-body, ${GuestBrandedDefaultFonts.body})`,
    },
};

export const CookieBannerHeaderStyles = {
    titleRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
    },
    title: {
        fontFamily: `var(--guest-branded-font-heading, ${GuestBrandedDefaultFonts.heading})`,
        fontSize: '1.5rem',
        fontWeight: 600,
    },
    description: {
        fontSize: '1rem',
        marginBottom: '0.5rem',
    },
    links: {
        fontSize: '0.875rem',
    },
    link: {
        fontFamily: `var(--guest-branded-font-button, ${GuestBrandedDefaultFonts.button})`,
        color: `var(--guest-branded-action, ${GuestBrandedDefaultColors.action})`,
    },
};

export const CookieBannerFooterStyles = {
    buttonRow: {
        display: 'flex',
        paddingTop: '16px',
        justifyContent: 'flex-end',
        alignItems: 'center',
        alignContent: 'center',
        gap: '8px',
        alignSelf: 'stretch',
        flexWrap: 'wrap',
        fontFamily: `var(--guest-branded-font-button, ${GuestBrandedDefaultFonts.button})`,
    },
};

export const CookieBannerConsentSettingsStyles = {
    container: {
        paddingTop: '16px',
        width: '100%',
    },
    header: {
        fontFamily: `var(--guest-branded-font-subHeading, ${GuestBrandedDefaultFonts.subHeading})`,
        fontSize: '1.125rem',
    },
    settingSection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '6px 0 6px 32px',
    },
    settingSwitch: {
        paddingLeft: '109px',
    },
    settingHeading: {
        fontFamily: `var(--guest-branded-font-subHeading, ${GuestBrandedDefaultFonts.subHeading})`,
        fontSize: '0.875rem',
        fontWeight: 600,
        paddingBottom: '8px',
    },
    settingDescription: {
        fontFamily: `var(--guest-branded-font-body, ${GuestBrandedDefaultFonts.body})`,
        fontSize: '0.875rem',
    },
    divider: {
        borderBottom: '1px solid #D9DCDE)',
        marginLeft: '32px',
    },
    alwaysOn: {
        fontFamily: `var(--guest-branded-font-body, ${GuestBrandedDefaultFonts.body})`,
        color: `var(--guest-branded-textHover, ${GuestBrandedDefaultColors.textHover})`,
        whiteSpace: 'nowrap',
    },
    button: {
        fontFamily: `var(--guest-branded-font-button, ${GuestBrandedDefaultFonts.button})`,
        display: 'flex',
        paddingTop: '24px',
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
};
